import Bugsnag from "@bugsnag/js"
import { getOfferPriceType, getPriceProperty } from "../../pricing"
import { errorsManager } from "../errors/errorsManager"

export function getCookieValue(name) {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(";").shift()

  return null
}

export function normalizeUtmKey(key) {
  return String(key)
    .trim()
    .replace(/\s+/g, "") // remove spaces
    .replace(/[-.]/g, "_") // kebab/dot -> snake
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2") // camel -> snake
    .replace(/__+/g, "_") // collapse multiple underscores
    .toLowerCase()
}

const utmKeyMap = {
  utm_source: "sourceUtm",
  utm_medium: "mediumUtm",
  utm_campaign: "campaignUtm",
  utm_term: "termUtm",
  utm_content: "contentUtm",
  fb_ads_id: "fbAdsId",
  fb_adset_id: "fbAdsetId",
}

export function getUTMParams() {
  const store = window.Alpine.store("data") || {}
  const storeData = (store && store.values) || {}

  const normalizedParams = {}
  for (const [k, v] of Object.entries(storeData)) {
    normalizedParams[normalizeUtmKey(k)] = v
  }

  const formattedParams = {}
  for (const [normalizedKey, outKey] of Object.entries(utmKeyMap)) {
    if (normalizedKey in normalizedParams) {
      formattedParams[outKey] = normalizedParams[normalizedKey]
    }
  }
  return formattedParams
}

export function generateUniqueId() {
  // Use crypto.randomUUID if available
  if (
    typeof window !== "undefined" &&
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
  ) {
    return window.crypto.randomUUID()
  }
  // Fallback: Generate a UUID-like string using Math.random()
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0
    let v = c === "x" ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function buildEventId({ orderId, pipelineId, offerPriceId }) {
  return [orderId, pipelineId, offerPriceId].join("-")
}

export function getOfferPriceTrackingProperties(offer) {
  const store = (window.Alpine && Alpine.store && Alpine.store("data")) || {}
  const activeOffer = offer || store?.values?.activeOffer

  if (!activeOffer) {
    errorsManager.reportError(new Error("[TrackingManager][GTM DataLayer] No offer found."))
    return null
  }

  const isChance = !!store?.values?.exitIntent
  const priceType = getOfferPriceType({ offer: activeOffer, isChance })

  const trackingProperties = getPriceProperty({
    offer: activeOffer,
    priceType,
    property: "trackingProperties",
  })

  if (!trackingProperties) {
    errorsManager.reportError(
      new Error(
        `[TrackingManager][GTM DataLayer] Missing trackingProperties for offer id: ${activeOffer?.id || "unknown"}.`,
      ),
    )
    return
  }

  return trackingProperties
}

export function getOfferPriceId(offer) {
  const store = (window.Alpine && Alpine.store && Alpine.store("data")) || {}
  const currentOffer = offer || store?.values?.activeOffer

  if (!currentOffer) {
    errorsManager.reportError(new Error("[TrackingManager][GTM DataLayer] No offer found."))
    return null
  }

  const isChance = !!store?.values?.exitIntent
  const priceType = getOfferPriceType({ offer: currentOffer, isChance })

  return getPriceProperty({
    offer: currentOffer,
    priceType: priceType,
    property: "id",
  })
}
